module.exports = __webpack_public_path__ + "img/icon_02.dbeed11e.png";